import { Flow } from "@/router/types";
import { SCREENS } from "@/router/screens";
import { Contract, Phase } from "@/types/contract";
import { isCustomerIdentified, skipTariffAndPayments } from "../helpers";
import { shouldCollectGDPRAgreements } from "@/utils/contract";

export const ZDP_SELF_SERVICE: Flow = {
  [SCREENS.WELCOME]: {
    next: (contract: Contract) => {
      if (isCustomerIdentified(contract)) {
        return SCREENS.CUSTOMER;
      }
      return SCREENS.IDENTIFICATION;
    },
    back: () => null,
  },
  [SCREENS.IDENTIFICATION]: {
    next: () => SCREENS.CUSTOMER,
    back: () => SCREENS.WELCOME,
  },
  [SCREENS.CUSTOMER]: {
    next: () => SCREENS.GUIDE,
    back: (contract: Contract) => (isCustomerIdentified(contract) ? SCREENS.IDENTIFICATION : SCREENS.WELCOME),
  },
  [SCREENS.GUIDE]: {
    next: () => SCREENS.SUPPLY_POINT,
    back: () => SCREENS.CUSTOMER,
  },
  [SCREENS.SUPPLY_POINT]: {
    next: (contract: Contract) => {
      if (skipTariffAndPayments(contract)) {
        return SCREENS.RECAPITULATION;
      }
      return SCREENS.PAYMENTS;
    },
    back: () => SCREENS.GUIDE,
  },
  [SCREENS.PAYMENTS]: {
    next: () => SCREENS.RECAPITULATION,
    back: () => SCREENS.SUPPLY_POINT,
  },
  [SCREENS.RECAPITULATION]: {
    next: (contract: Contract, options?: { gdprAgreed?: boolean; isContractRequest?: boolean }) => {
      if (contract.phase === Phase.LEAD) {
        return SCREENS.THANK_YOU;
      }
      return !options?.gdprAgreed && shouldCollectGDPRAgreements(contract, options?.isContractRequest ?? false)
        ? SCREENS.AGREEMENTS
        : SCREENS.VIEW;
    },
    back: (contract: Contract) => {
      if (skipTariffAndPayments(contract)) {
        return SCREENS.SUPPLY_POINT;
      }
      return SCREENS.PAYMENTS;
    },
  },
  [SCREENS.AGREEMENTS]: {
    next: () => SCREENS.VIEW,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.VIEW]: {
    next: () => SCREENS.SIGNATURE,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.SIGNATURE]: {
    next: () => SCREENS.SMS_CODE,
    back: () => SCREENS.VIEW,
  },
  [SCREENS.SIGNATURE_ON_PHONE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => null,
  },
  [SCREENS.SMS_CODE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => SCREENS.SIGNATURE,
  },
  [SCREENS.THANK_YOU]: {
    next: () => null,
    back: () => null,
  },
};
